<template>
    <div>
        <header>
            <div class="header">
                <div class="container">
                    <div class="row">
                        <div class="col-12 col-md-4 col-xl-6">
                            <img :src="logoBranca" />
                        </div>
                        <div class="col-12 col-md-8 col-xl-6 mt-3 mt-sm-0">
                            <div class="d-flex justify-content-between">
                                <div class="d-flex flex-column justify-content-between">
                                    <span class="txt-p txt-white">SEJA ASSINANTE</span>
                                    <p class="txt-l txt-azul-5">Tenha acesso a todas as ferramentas do Sollicita</p>
                                    <a class="btn btn-roxo w-100" :href="urlPlanos" target="_blank">Conheça agora</a>
                                </div>
                                <div class="divisor mx-1 d-none d-sm-block"></div>
                                <div class="">
                                    <div class="d-flex justify-content-between mb-1">
                                        <div>
                                            <a class="txt-l txt-white" href="javascript:void(0)" @click="esqueciMinhaSenha">Esqueci a Senha</a>
                                        </div>
                                        <div class="divisor"></div>
                                        <div>
                                            <a class="txt-l txt-white" href="javascript:void(0)" @click="autoatendimento">Autoatendimento</a>
                                        </div>

                                    </div>
                                    <form>
                                        <div class="mb-1">
                                            <input class="w-100 input-text" type="text" placeholder="Usuário" v-model="user.login" required />
                                        </div>
                                        <div class="d-flex">
                                            <input class="input-text" type="password" name="senha" value="" placeholder="Senha" v-model="user.password" v-on:keyup.enter="entrar" required />
                                            <button class="btn btn-roxo ms-1" type="button" @click="entrar"> Entrar </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                       
                    </div>

                </div>
            </div>
            <div class="menu">
                <div class="container">
                    <div class="row">
                        <div class="col-12 col-md-12 d-flex align-items-center justify-content-center">
                            <div class=" d-flex">
                                <router-link :to="item.path" :class="(subIsActive(item) ? 'txt-h-4 txt-white me-2 me-md-4 menu-active py-3':'txt-h-4 txt-white me-2 me-md-4 py-3')" v-for="(item) in routes" :key="item.name">
                                    {{item.name.toLocaleUpperCase()}}
                                </router-link>

                            </div>
                            <div class="divisor-menu d-none d-sm-block">
                                <a class="link-sollicita ms-3" :href="urlPortalNoticias" target="_blank">Portal de notícias <i class="fas fa-external-link-alt ms-1"></i></a>
                            </div>
                        </div>
                        <div class="col-12 my-2 text-center d-block d-sm-none">
                            <a class="link-sollicita ms-3" :href="urlPortalNoticias" target="_blank">Portal de notícias <i class="fas fa-external-link-alt ms-1"></i></a>
                        </div>
                    </div>
                </div>
            </div>

        </header>
        <EsqueciMinhaSenha :showModal="showModal"></EsqueciMinhaSenha>
    </div>
</template>

<script>
    import logoBranca from '@/assets/img/logo-branca.png'
    import { urlApi, avisoErro, urlPortal, urlPlanos } from '@/config/global'
    import axios from 'axios'
    import EsqueciMinhaSenha from '@/components/EsqueciMinhaSenha'

    export default {
        name: 'Header',
        components: { EsqueciMinhaSenha },
        data: function () {
            return {
                logoBranca,
                routes: this.$router.options.routes.filter(x => x.meta != undefined && x.meta.authenticated == false),
                user: {
                    login: "",
                    password: "",
                    cdProduto: "SO",
                },
                urlPortalNoticias: urlPortal,
                showModal: false,
                urlPlanos,
            }
        },
        methods: {
            
            subIsActive(input) {
                let name = this.$route.name.split('-')[0];
                return name == input.name;
            },

            entrar(event) {
                event.preventDefault();
                if (this.checkForm()) {
                    //var loading = this.$loading.show({});
                    let $this = this;
                    axios.post(`${urlApi}/Auth/signin`, this.user)
                        .then(res => {
                            if (res.data.token.authenticated) {
                                res.data.token.usuario = res.data.usuario;
                                res.data.token.usuario.idContrato = res.data.idContrato;
                                res.data.token.usuario.tpPessoa = res.data.tpPessoa;
                                res.data.token.usuario.flCortesia = res.data.flCortesia;
                                $this.$store.commit('setUser', res.data.token)
                                $this.$router.push({ name: 'HomeLogado'});
                            } else {
                                avisoErro("Erro ao realizar login.");
                            }
                            //loading.hide();
                        })
                        .catch(err => {
                            if (err.response.data && err.response.data.msg) {
                                var msg = err.response.data.msg + '. ' + err.response.data.errors[0];
                                avisoErro(msg);
                            } else {
                                avisoErro("Login e/ou senha inválidos.");
                            }
                            
                            //avisoErro(res.response.statusText);
                            //loading.hide();
                        })
                }

                return false;
            },


            checkForm() {
                var form = document.querySelector('form')
                if (!form.checkValidity()) {
                    var tmpSubmit = document.createElement('button')
                    form.appendChild(tmpSubmit)
                    tmpSubmit.click()
                    form.removeChild(tmpSubmit)

                    return false;
                }

                return true;
            },

            esqueciMinhaSenha() {
                this.showModal = !this.showModal;
            },

            autoatendimento() {
                document.getElementById('blip-chat-icon').click();
            }
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    header {
    }

    .divisor{
        border-right: 1px solid #FFF;
    }

    .divisor-menu {
        height: 55%;
        border-left: 2px solid #42304F;
    }

    .header {
        background: linear-gradient(98.19deg, #163142 1.55%, #281D2E 61.54%, #163142 100%);
        padding: 24px 0;
    }

    .menu {
        background: linear-gradient(0deg, rgba(17, 35, 48, 0.5), rgba(17, 35, 48, 0.5)), url(../assets/img/bg-header.svg);
        /*padding: 10px 0;*/
    }

    .menu-active {
        border-bottom: 5px solid #FFF;
    }

    .link-sollicita {
        font-family: Nunito;
        font-style: normal;
        font-weight: 800;
        font-size: 14px;
        line-height: 140.62%;
        color: #FBBC0D;
        text-transform: uppercase;
    }
</style>

